import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import GlobalPopup from './globalPopup';

let showPopupExternal;

export const showPopup = ({ title, message, onConfirm, onCancel, cancel, ok, cancelClassName }) => {
  if (showPopupExternal) {
    showPopupExternal({ title, message, onConfirm, onCancel, cancel, ok, cancelClassName });
  }
};

const GlobalPopupContainer = () => {
  const [popupProps, setPopupProps] = useState({
    open: false,
    title: '',
    message: '',
    cancel:'',
    ok:'',
    onConfirm: null,
    onCancel: null,
    cancelClassName: '',
  });

  useEffect(() => {
    showPopupExternal = ({ title, message, onConfirm, onCancel, cancel, ok, cancelClassName }) => {
      setPopupProps({
        open: true,
        title,
        message,
        onConfirm,
        onCancel,
        cancel,
        ok,
        cancelClassName,
      });
    };
  }, []);

  const handleClose = () => {
    popupProps.onCancel?.();
    setPopupProps(prev => ({ ...prev, open: false }));
  };

  const handleConfirm = () => {
    popupProps.onConfirm?.();
    setPopupProps(prev => ({ ...prev, open: false }));

  };




  return (
    <GlobalPopup
      open={popupProps.open}
      title={popupProps.title}
      cancel={popupProps.cancel}
      ok={popupProps.ok}
      message={popupProps.message}
      onClose={handleClose}
      onConfirm={handleConfirm}
      cancelClassName={popupProps.cancelClassName}
    />
  );
};

export const renderGlobalPopup = () => {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);
  root.render(<GlobalPopupContainer />);
};
